export default function distributeRatio(userType,showType = "youke"){

  if(userType==null){
    return (
      <div style="width:165px;position:relative">
        <div style="position: absolute;top: -2px;" className="u2diSliderHandler"></div>
        <div style="position: absolute;top: -16px;left: 20px;" className={showType==="admin"?"u2diCircleWhite":"u2diCircleGreen"}>50%</div>
        <div style="position: absolute;top: -16px;left: 115px;" className={showType==="admin"?"u2diCircleGreen":"u2diCircleWhite"}>50%</div>
        <div style="position: absolute;top: -2px;right:0px" className="u2diSliderHandler"></div>
        <hr style="border-top: 1.5px solid #999;" />
      </div>
    );
  }else if(userType==0){
    return (
      <div style="width:165px;position:relative">
        <div style="position: absolute;top: -2px;" className="u2diSliderHandler"></div>
        <div style="position: absolute;top: -16px;left: 20px;" className={showType==="admin"?"u2diCircleWhite":"u2diCircleGreen"}>35%</div>
        <div style="position: absolute;top: -16px;left: 68px;" className={showType==="admin"?"u2diCircleGreen":"u2diCircleWhite"}>30%</div>
        <div style="position: absolute;top: -16px;left: 115px;" className="u2diCircleWhite">35%</div>
        <div style="position: absolute;top: -2px;right:0px" className="u2diSliderHandler"></div>
        <hr style="border-top: 1.5px solid #999;" />
      </div>
    );
  }
}